module.exports = __webpack_public_path__ + "static/gabriel-c2c23fd5997cd511f238badb9de1b67a.jpg";